import { Loading } from "../../utils/helpers/constants";
import * as AgentConstants from "../constants/agent.constants";

const initialState = {
  partner_agent_branch: [],
  loadingPartnerAgentBranch: "",
  approve_disapprove_agent: [],
  loadingApproveDisapproveAgent: "",
};

const agentReducer = (state = initialState, action) => {
  switch (action.type) {
    case AgentConstants.PARTNER_AGENT_BRANCH_REQUEST:
      return { ...state, loadingPartnerAgentBranch: Loading.FETCHING };

    case AgentConstants.PARTNER_AGENT_BRANCH_SUCCESS:
      return {
        ...state,
        loadingPartnerAgentBranch: Loading.SUCCESS,
        partner_agent_branch: action.payload,
      };

    case AgentConstants.PARTNER_AGENT_BRANCH_FAILURE:
      return {
        ...state,
        loadingPartnerAgentBranch: Loading.ERROR,
      };

    case AgentConstants.APPROVE_DISAPPROVE_AGENT_REQUEST:
      return { ...state, loadingApproveDisapproveAgent: Loading.FETCHING };

    case AgentConstants.APPROVE_DISAPPROVE_AGENT_SUCCESS:
      return {
        ...state,
        loadingApproveDisapproveAgent: Loading.SUCCESS,
        approve_disapprove_agent: action.payload,
      };

    case AgentConstants.APPROVE_DISAPPROVE_AGENT_FAILURE:
      return {
        ...state,
        loadingApproveDisapproveAgent: Loading.ERROR,
      };

    default:
      return state;
  }
};

export default agentReducer;
